
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors } from '@aston/foundation';
import { NewAccountStep } from 'apps/console/src/app/account-module/enums';

import { FeatureName } from './feature';
import { INewAccountState } from './state';

export const selectState: MemoizedSelector<object, INewAccountState> = createFeatureSelector<INewAccountState>(FeatureName);

export const getCurrentStep = (state: INewAccountState): NewAccountStep => state.currentStep;
export const selectCurrentStep = createSelector(selectState, state => getCurrentStep(state));

export const getIsSubsidiaryNotInitialized = (state: INewAccountState): boolean => !state.isSubsidiaryInitialized;
export const selectIsSubsidiaryNotInitialized  = createSelector(selectState, state => getIsSubsidiaryNotInitialized(state));

export const {
	selectSlice: selectSelectedSubsidiarySlice,
	selectEntity: selectSelectedSubsidiary,
	selectIsLoading: selectSelectedSubsidiaryIsLoading,
	selectError: selectSelectedSubsidiaryError
} = createEntitySliceSelectors(createSelector(selectState, state => state.selectedSubsidiary));

export const selectHasCreationBeenCanceled = createSelector(selectState, state => state.creationCanceled);

export const {
	selectEntity: selectSubsidiaryForm,
	selectIsLoading: selectSubsidiaryFormIsLoading,
	selectError: selectSubsidiaryFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryForm));

export const {
	selectEntity: selectSubsidiaryBlockedForm,
	selectIsLoading: selectSubsidiaryBlockedFormIsLoading,
	selectError: selectSubsidiaryBlockedFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryBlockedForm));

export const {
	selectEntity: selectSubsidiaryFromLegalIdentifier,
	selectIsLoading: selectSubsidiaryFromLegalIdentifierIsLoading,
	selectError: selectSubsidiaryFromLegalIdentifierError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subsidiaryFromLegalIdentifier));

export const {
	selectEntity: selectSubscriptionForm,
	selectIsLoading: selectSubscriptionFormIsLoading,
	selectError: selectSubscriptionFormError
} = createEntitySliceSelectors(createSelector(selectState, state => state.subscriptionForm));
